import Router from 'next/router'

import { buildSpaceDetailHref } from 'features/space/lib/buildSpaceDetailHref'
import { resolveCanonicalSpaceUuid } from 'features/space/lib/resolveCanonicalSpaceUuid'

/**
 * LocalStorageに保存されている
 * 検索パラメーターに redirect_urlが存在していたら、そのURLにリダイレクトさせる
 */
export function authRedirect() {
  const lockerBookingParams = JSON.parse(sessionStorage.getItem('lockerBookingInfo'))

  if (lockerBookingParams && lockerBookingParams.lockerId) {
    const lockerId = String(lockerBookingParams.lockerId)
    const destination =
      buildSpaceDetailHref({
        spaceType: 'locker',
        spaceUuid: resolveCanonicalSpaceUuid(lockerId),
        encryptedId: lockerId,
      }) ?? `/locker/${lockerId}`

    Router.push(destination)
    return
  }

  const localStorageParams = JSON.parse(localStorage.getItem('search_params'))
  localStorageParams?.redirect_url
    ? Router.push(localStorageParams.redirect_url)
    : Router.push('/locations?test=1')
}
